import React, { useState, useEffect } from "react";
import {
  Box,
  Container,
  Typography,
  Grid,
} from "@mui/material";
import { styled, keyframes } from "@mui/material/styles";
import logo from "../../images/logo1.png";

// Animations
const fadeInLeft = keyframes`
  from {
    opacity: 0;
    transform: translateX(-40px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

const fadeInRight = keyframes`
  from {
    opacity: 0;
    transform: translateX(40px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

// Styled Components
const BackgroundBox = styled(Box)({
  position: "relative",
  minHeight: "100vh",
  background: "linear-gradient(180deg, #000000 0%, #0a0a0a 50%, #000000 100%)",
  overflow: "hidden",
  display: "flex",
  alignItems: "center",
  paddingTop: "80px",
  paddingBottom: "80px",
});

const GradientOrb = styled(Box)(({ top, left, bottom, right, color }) => ({
  position: "absolute",
  width: 500,
  height: 500,
  borderRadius: "50%",
  background: color,
  filter: "blur(100px)",
  pointerEvents: "none",
  top,
  left,
  bottom,
  right,
}));

const GridPattern = styled(Box)({
  position: "absolute",
  inset: 0,
  opacity: 0.05,
  backgroundImage: `linear-gradient(rgba(148, 163, 184, 0.1) 1px, transparent 1px),
                     linear-gradient(90deg, rgba(148, 163, 184, 0.1) 1px, transparent 1px)`,
  backgroundSize: "50px 50px",
  pointerEvents: "none",
});

const LogoImage = styled("img")({
  width: "100%",
  maxWidth: 300,
  height: "auto",
  filter: "drop-shadow(0 20px 60px rgba(193, 227, 40, 0.5))",
  transition: "transform 0.5s ease",
  "&:hover": {
    transform: "scale(1.05)",
  },
});

const About = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setTimeout(() => setIsVisible(true), 100);
  }, []);

  return (
    <BackgroundBox>
      {/* Background Elements */}
      <GradientOrb top="20%" left={-256} color="rgba(193, 227, 40, 0.1)" />
      <GradientOrb bottom="20%" right={-256} color="rgba(193, 227, 40, 0.1)" />
      <GridPattern />

      <Container maxWidth="lg" sx={{ position: "relative", zIndex: 1 }}>
        <Grid container spacing={8} alignItems="center">
          {/* Content Section */}
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                animation: isVisible ? `${fadeInLeft} 0.8s ease-out` : "none",
              }}
            >
              {/* Brand Name */}
              
              <Typography
                variant="h1"
                sx={{
                  fontSize: { xs: "3rem", sm: "4rem", md: "4.5rem" },
                  fontWeight: 700,
                  mb: 3,
                  letterSpacing: 2,
                  lineHeight: 1.1,
                  background: "linear-gradient(135deg, #c1e328 0%, #9fcc2e 100%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                AUTOGENBOT
              </Typography>

              {/* Description */}
              <Typography
                variant="h5"
                sx={{
                  color: "rgba(203, 213, 225, 1)",
                  lineHeight: 1.7,
                  fontSize: { xs: "1.125rem", md: "1.375rem" },
                  fontWeight: 400,
                  mb: 2,
                }}
              >
             Building the Future of Physical AI
             for offroad robotic mobility
              </Typography>

              {/* <Typography
                variant="h6"
                sx={{
                  color: "rgba(148, 163, 184, 1)",
                  lineHeight: 1.7,
                  fontSize: { xs: "1rem", md: "1.125rem" },
                  fontWeight: 400,
                }}
              >
               Building the Future of Physical AI
               for offroad robotic mobility
              </Typography> */}
            </Box>
          </Grid>

          {/* Logo Section */}
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                animation: isVisible ? `${fadeInRight} 0.8s ease-out 0.2s both` : "none",
              }}
            >
              <LogoImage src={logo} alt="Autogenbot Logo" />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </BackgroundBox>
  );
};

export default About;
